import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toggleArchive } from "../api";
import { projectsKeys } from "../queries/index";
import type { Project, ProjectsListResponse } from "../../types";

interface ToggleArchiveParams {
  id: number;
  value: boolean;
}

// Mutation hook for toggling archive status
export const useToggleArchiveMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, value }: ToggleArchiveParams) => {
      const response = await toggleArchive(id, value);
      return response.data;
    },
    onSuccess: (_data, variables) => {
      const { id } = variables;

      // Update all list queries
      queryClient.setQueriesData<ProjectsListResponse>(
        { queryKey: [...projectsKeys.all, "list"] },
        (oldData) => {
          if (!oldData?.data) return oldData;
          return {
            ...oldData,
            data: oldData.data.map((project: Project) =>
              project.id === id
                ? { ...project, isArchived: !project.isArchived }
                : project,
            ),
          };
        },
      );
    },
  });
};
